export const buildTestDetailPath = (testSlugOrId: string | null | undefined): string | null =>
  testSlugOrId ? `/tests/${testSlugOrId}` : null;

export const buildSuiteDetailPath = (suiteSlugOrId: string | null | undefined): string | null =>
  suiteSlugOrId ? `/suites/${suiteSlugOrId}` : null;

export const buildTestRunPath = (
  testSlugOrId: string | null | undefined,
  runNumber: number | null | undefined,
): string | null => (testSlugOrId ? `/tests/${testSlugOrId}/runs/${runNumber ?? 1}` : null);

export const buildSuiteRunPath = (
  suiteSlugOrId: string | null | undefined,
  runNumber: number | null | undefined,
): string | null => (suiteSlugOrId ? `/suites/${suiteSlugOrId}/runs/${runNumber ?? 1}` : null);

export const buildExecutionRunDetailPath = (runId: string | null | undefined): string | null =>
  runId ? `/execution-runs/${runId}` : null;

export const buildResultsFileDetailPath = (
  resultsFileId: string | null | undefined,
): string | null => (resultsFileId ? `/results-files/${resultsFileId}` : null);
